var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Dropdown",
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.945,
    height: 4.906,
    viewBox: "0 0 7.945 4.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_expand_less_24px",
    d: "M9.972,8,6,11.972l.933.933L9.972,9.874l3.039,3.032.933-.933Z",
    transform: "translate(13.945 12.906) rotate(180)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.b0ff53fd297fecea336c4b57d7521fba.svg";
export { ForwardRef as ReactComponent };